import { ApiResponse } from "@/api/types";
import { Props as OnboardingFloatingViewProps } from "@/components/Organisms/OnboardingFloatingView/Organisms/Panel/types";
export interface OnboardingData {
  recruitmentNumber: number;
  universities: ApiResponse.CompactUniversities["universities"];
  companies: ApiResponse.Company[];
}
export enum OnboardingStatusType {
  "NOT_YET" = "NOT_YET",
  "DONE_STEP1" = "DONE_STEP1",
  "DONE" = "DON2"
}

export enum StepRange {
  "MIN_STEP" = 1,
  "MAX_STEP" = 3
}

export interface OnboardingSnapShot {
  onboardingData: OnboardingData;
  currentStep: number;
}

export interface ContainerData {
  loading: boolean;
  currentStep: number;
  onboardingStatus?: OnboardingStatusType;
  onboardingData: OnboardingData;
}
export interface ContainerComputed {
  isLoggedIn: boolean;
  partnerUser: ApiResponse.PartnerUser | undefined;
  isOnboardingFinished: boolean | undefined;
  isRecruitmentNumberRegistered: boolean | undefined;
  onboardingSnapShot: OnboardingSnapShot;
}
export interface ContainerProps {}
export interface ContainerMethods {
  changeCurrentStep: (currentStep: number) => void;
  checkOnboardingStatus: () => void;
  compleatOnboarding: () => void;
  changeOnboardingData: (onboardingData: OnboardingData) => void;
  restoreOnboardingSnapShot: () => void;
}

export interface Data {
  OnboardingStatusType: typeof OnboardingStatusType;
}
export interface Computed {
  stepSettings: OnboardingFloatingViewProps["stepSettings"];
  currentStepSetting: OnboardingFloatingViewProps["stepSettings"][number];
}
export interface Props {
  isShow: boolean;
  loading: boolean;
  currentStep: number;
  onboardingStatus: OnboardingStatusType;
  onboardingData: OnboardingData;
}
export interface Methods {
  handleClickNext: () => void;
  handleClickBack: () => void;
  handleClickSubmit: () => void;
  handleChangeRecruitmentNumber: (
    recruitmentNumber: OnboardingData["recruitmentNumber"]
  ) => void;
  handleChangeUniversities: (
    universities: OnboardingData["universities"]
  ) => void;
  handleChangeCompanies: (companies: OnboardingData["companies"]) => void;
}
